import { useQuery } from "react-query";
import { RoleMap } from "../../types/layer";
import layerKeys from "queryKeyFactory/layerKeys";
import { getLayersByRoleAndClient } from "services/layer-service";

type Params = {
    roleId: string;
    successCb?: (data: Array<RoleMap>) => void
}

export default function useGetLayersByRoleAndClient({ roleId, successCb }: Params) {
    const clientId = localStorage.getItem("client_id") ?? "";
    return useQuery<any, Error, Array<RoleMap>>(layerKeys.layersByRoleAndClient(roleId, clientId), () => getLayersByRoleAndClient(roleId, clientId), {
        enabled: !!(roleId && clientId),
        select: (res) => res.data?.maps,
        onSuccess: (data) => successCb && successCb(data),
        refetchOnWindowFocus: false,
    })
}